module.exports = __webpack_public_path__ + "static/media/ericsson.5cef7abd.png";